import { render, staticRenderFns } from "./FlexibleDepositConfirmation.vue?vue&type=template&id=a8cb124a&"
import script from "./FlexibleDepositConfirmation.vue?vue&type=script&lang=ts&"
export * from "./FlexibleDepositConfirmation.vue?vue&type=script&lang=ts&"
import style0 from "./FlexibleDepositConfirmation.vue?vue&type=style&index=0&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
